import { useLazyQuery } from "@apollo/client";
import { ACC_GET_CACHE } from "components/gql/gql_queries_acc";
import { GetAlertData } from "contexts/AlertContext";
import { logGQLError } from "data/functions";

export function GetCacheQuery() {
  const queryName = "GetCache";
  const { setAlert } = GetAlertData();
  const [refetch, variables] = useLazyQuery(ACC_GET_CACHE, {
    fetchPolicy: "no-cache",
    // notifyOnNetworkStatusChange: true,
    variables: {
      workspace: "5s_pay",
    },
    // onCompleted: (data) => {
    //   let res = data?.export_companyEquipments;
    //   if (isObjectEmpty(res)) {
    //     forceSetDataObj([], "equipments");
    //   } else if (!isIdentical(res, dataObj?.equipments)) {
    //     consoleBeauty("Получен список оборудования", "GraphQL", "darkgreen");
    //     forceSetDataObj(res, "equipments");
    //   }
    // },
    onError: (e) => {
      // setAlert("Ошибка при получении кэша!", "error");
      logGQLError(queryName, e);
    },
  });
  return [refetch, variables];
}
